import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  create(params) {
    const url = apiRoutes.sharesPath(1, params);
    return FetchHelpers.post(url, params);
  },
};
